// @flow
import { connect } from 'react-redux'
import AdEditWrapper from './AdEditWrapper'
import * as editWrapperActions from '../redux/ducks/adEditWrapper/reducers'
import * as adActions from '../redux/ducks/advertisements/reducers'
import * as adOperations from '../redux/ducks/advertisements/operations'
import * as replicaOperations from '../redux/ducks/advertisementReplicas/operations'
import { getAdvertisement, getReplicaAdvertisement } from '../redux/selectors'
import _ from 'lodash'
import type { Store } from '../redux/ducks'
import type { ErrorsPack } from './initErrorsFromResponse'
import getJson from '../services/getJson'
import postJson from '../services/postJson'
import { Audience } from './constants'
import type { RawAdvertisement } from '../redux/ducks/AdvertisementDataAdapter'
import scrollToTop from '../shared/scrollToTop'
import { processAdvertisementErrors } from './initErrorsFromResponse'
import store from '../redux/store'
import type { ProviderTemplateFieldsInfo, ValidatedAdvertisementWithStoredMedia } from './types'
import { advertisementsPayload } from './prepareProviderTemplateBlocks'

function mapStateToProps(state: Store, ownProps) {
  const { storeIds, providers, urlCheck, fbPromotionPosts } = state.adEditWrapper
  const { audienceData } = ownProps

  return {
    storeIds,
    audienceData: { ...audienceData, providers },
    urlCheck,
    fbPromotionPosts,
    isPromotionUrlEditDisabled:
      ownProps.submitMethod === 'put' &&
      audienceData.audienceType === Audience.types.posts_promotion,
    ownProps
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: Object) {
  return {
    onInit: () => {
      if (ownProps.action === 'create') {
        dispatch(
          editWrapperActions.init({
            templates: {},
            advertisement_template_id: null,
            url_check: null
          })
        )
      } else {
        getJson(`/advertisements/${ownProps.id}/data`).done((advertisement: RawAdvertisement) => {
          dispatch(editWrapperActions.init(advertisement))
          dispatch(editWrapperActions.patch({ urlCheck: advertisement.url_check }))
        })
      }
      if (ownProps.audienceData.audienceType === Audience.types.posts_promotion) {
        postJson('/advertisements/fb_published_posts', {
          audience_ids: [ownProps.selectedAudienceId]
        }).done((response) => {
          dispatch(editWrapperActions.patch({ fbPromotionPosts: response.result }))
        })
      }
    },
    onChange: (diff) => {
      dispatch(editWrapperActions.patch(diff))
    },
    onAdvertisementChange: (storeIds, diff) => {
      _.map(storeIds, (storeId) => dispatch(adActions.patch(storeId, diff)))
    },
    onAdvertisementErrors: (storeId: string, errors: Array<ErrorsPack>) => {
      adOperations.putErrors(storeId, errors[0])
      _.each(errors, (item, index: number) => {
        if (index === 0) return
        replicaOperations.putErrors(index - 1, item)
      })
    },
    onPersist: (status: string) => makeRequest(ownProps, dispatch, status)
  }
}

function makeRequest(ownProps: Object, dispatch: Function, status: string) {
  const { submitMethod, submitPath, selectedAudienceId } = ownProps
  const isCreating = submitMethod === 'post'

  dispatch(editWrapperActions.patch({ isLoading: true }))

  const audienceData = ownProps.audienceData
  const state = store.getState()
  postJson(isCreating ? `/api/v1/audiences/${selectedAudienceId}/advertisements` : submitPath, {
    data: {
      status: status,
      items: advertisementsPayload(
        payloadAdvertisements(state),
        state.adEditWrapper.providers,
        audienceData.audienceType,
        audienceData.placementType,
        audienceData.vkPlacement
      )
    }
  })
    .then((response) => {
      if (response.success) {
        const redirectTo = `/audiences/${selectedAudienceId}/advertisements${
          isCreating ? '?ads_create_ok=ok' : ''
        }`
        window.location = redirectTo
      } else {
        dispatch(editWrapperActions.patch({ isLoading: false }))
        window.alert('Process error!')
      }
    })
    .fail((e: any) => {
      if (e.status === 422) {
        processErrors(store.getState(), e.responseJSON.message)
        scrollToTop()
      } else {
        window.alert('Request error!')
      }
      dispatch(editWrapperActions.patch({ isLoading: false }))
    })
}

function payloadAdvertisements(state: Store): Array<ValidatedAdvertisementWithStoredMedia> {
  const storeIds = state.adEditWrapper.storeIds
  const advertisements = _.map(storeIds, (storeId) => {
    return getAdvertisement(state, storeId)
  })
  const replicaAdvertisements = _.map(state.advertisementReplicas, (_replica, index: number) => {
    return getReplicaAdvertisement(state, storeIds[0], index)
  })

  return [...advertisements, ...replicaAdvertisements]
}

function processErrors(state, errors: {| items: Array<$Shape<ProviderTemplateFieldsInfo<any>>> |}) {
  const storeId = state.adEditWrapper.storeIds[0]
  const adErrors = _.map(errors.items, (item) => processAdvertisementErrors(item))

  adOperations.putErrors(storeId, adErrors[0])
  _.each(adErrors, (item, index: number) => {
    if (index === 0) return
    replicaOperations.putErrors(index - 1, item)
  })
}

const AdEditWrapperContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AdEditWrapper)

export default AdEditWrapperContainer
